import { Box, HStack, Text } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const FeeDeliveryItem = Text.withConfig({
  color: getDesignToken('alert-warning-background'),
  fontWeight: 'bold',
});

export const Total = Box.withConfig({
  focusable: true,
});

export const GrandTotalLabel = Text.withConfig({
  flexGrow: 1,
  color: getDesignToken('text-default'),
  fontSize: 'md',
  fontWeight: 'bold',
  focusable: true,
});

export const TotalLabel = Text.withConfig<{ isFreeDelivery?: boolean; color?: string }>(p => ({
  flexGrow: 1,
  color:
    p.color ||
    (p.isFreeDelivery
      ? getDesignToken('alert-warning-background')
      : getDesignToken('text-default')),
  fontSize: 'md',
  fontWeight: p.isFreeDelivery ? 'bold' : 'normal',
  focusable: true,
}));

export const DonationLabel = Text.withConfig({
  color: getDesignToken('text-default'),
  fontWeight: 'normal',
});

export const TotalLabelContainer = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  height: '$6',
  focusable: true,
});

export const TotalsRow = HStack;
